import React from "react"
import PropTypes from "prop-types";
import _ from 'lodash';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faQuestion } from "@fortawesome/free-solid-svg-icons"

class ThemeButton extends React.Component {
  render () {



    return (
      <button
        className={`theme-button ${this.props.selected ? 'selected' : ''} ${this.props.hasValue ? 'green-shadow' : null}`}
        onClick={() => this.props.handleClick(this.props.theme)}
      >

        {/*<h4>{_.capitalize(this.props.theme)}</h4>*/}
        {this.props.iconPath &&
          <img
            src={this.props.iconPath}
            alt={this.props.theme + ' logo'}
            className='theme-icon'
          />
        }
        {!this.props.iconPath &&
          <FontAwesomeIcon
            icon={faQuestion}
            style={{fontSize: '3rem'}}
            color='white'
          />
        }

      </button>
    );
  }
}

export default ThemeButton
